import styled from "styled-components";

/**
 * Layout and structural components for the assembly planner page
 */
export const AssemblyLayout = {
    Page: styled.div`
      padding: 16px;
      display: grid;
      grid-template-columns: 260px 1fr;
      gap: 16px;
    `,
    Palette: styled.div`
      border: 1px solid #d9e2ec;
      background: #f8fbff;
      border-radius: 10px;
      padding: 12px;
      display: flex;
      flex-direction: column;
      gap: 12px;
    `,
    PaletteTitle: styled.div`
      font-weight: 700;
      color: #0b3d91;
      display: flex;
      justify-content: space-between;
      align-items: center;
    `,
    PaletteGroup: styled.div`
      display: flex;
      flex-direction: column;
      gap: 8px;
    `,
    Draggable: styled.div<{ $color: string }>`
      border: 1px dashed ${props => props.$color};
      background: rgba(59,130,246,0.05);
      border-radius: 10px;
      padding: 10px;
      display: flex;
      gap: 10px;
      align-items: center;
      cursor: grab;
    `,
    Chip: styled.div<{ $color: string }>`
      width: 34px;
      height: 34px;
      border-radius: 999px;
      background: ${props => props.$color};
      color: #0b2545;
      font-weight: 800;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: inset 0 1px 0 rgba(255,255,255,0.65);
    `,
    BoardShell: styled.div`
      border: 1px solid #d9e2ec;
      background: #f4f8fb;
      border-radius: 12px;
      padding: 12px;
      min-height: 460px;
      position: relative;
      overflow: hidden;
    `,
    BoardHeader: styled.div`
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      gap: 12px;
      flex-wrap: wrap;
    `,
    BoardTitle: styled.div`
      font-weight: 700;
      color: #0f172a;
      display: flex;
      gap: 8px;
      align-items: center;
    `,
    BoardCanvas: styled.div`
      position: relative;
      min-height: 600px;
      height: 70vh;
      border: 1px dashed #cbd5e1;
      background: white;
      border-radius: 10px;
      overflow: hidden;
      touch-action: none;
    `,
    ZoomControls: styled.div`
      position: absolute;
      bottom: 16px;
      right: 16px;
      display: flex;
      flex-direction: column;
      gap: 8px;
      z-index: 20;
    `,
    ZoomButton: styled.button`
      width: 40px;
      height: 40px;
      border-radius: 8px;
      border: 1px solid #cbd5e1;
      background: white;
      color: #0f172a;
      font-size: 20px;
      font-weight: 700;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      &:hover {
        background: #f1f5f9;
        border-color: #3b82f6;
      }
      &:active {
        transform: scale(0.95);
      }
      &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
    `,
    ZoomLevel: styled.div`
      background: white;
      border: 1px solid #cbd5e1;
      border-radius: 6px;
      padding: 4px 8px;
      font-size: 12px;
      font-weight: 600;
      text-align: center;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    `,
};
